import React from "react";

function Footer() {
    return (
        <footer>
            <p>Made by &copy; Ann Kemp</p>
        </footer>
    );
}

export default Footer;